
 $(document).ready(function() {
	 	var dirRtlFlag = false;
  if ($("html").attr('dir') == 'rtl') {
    dirRtlFlag = true;
   }

 $('.art-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 2000,
  autoplay: true,
  autoplaySpeed: 100,
  rtl: dirRtlFlag,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: $('.banner-slider__prev'),
  nextArrow: $('.banner-slider__next'),
	responsive: [
    {
      breakpoint: 1550,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
      }
      },
	  {
		breakpoint: 1024,
		settings: {
		  slidesToShow: 3,
		  slidesToScroll: 1,
		  infinite: true,
		}
	  },
	  {
		breakpoint: 780,
		settings: {
		  slidesToShow: 2,
		  slidesToScroll: 1
		}
	  },
	  {
		breakpoint: 480,
		settings: {
		  slidesToShow: 1,
		  slidesToScroll: 1
		}
	  }
	  // You can unslick at a given breakpoint now by adding:
	  // settings: "unslick"
	  // instead of a settings object
	] 
  });

  $('.art-slider1').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 2000,
  autoplay: true,
  autoplaySpeed: 100,
    rtl: dirRtlFlag,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: $('.banner-slider1__prev'),
    nextArrow: $('.banner-slider1__next'),
    responsive: [
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        }
        },
      {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
      },
      {
      breakpoint: 780,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
      },
      {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ] 
    });

    $('.art-slider2').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 2000,
  autoplay: true,
  autoplaySpeed: 100,
      rtl: dirRtlFlag,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: $('.banner-slider2__prev'),
      nextArrow: $('.banner-slider2__next'),
      responsive: [
        {
          breakpoint: 1550,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
          }
          },
        {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
        },
        {
        breakpoint: 780,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
        },
        {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ] 
      });

      $('.artic-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 800,
    autoplay: true,
    autoplaySpeed: 500,
        // rtl: dirRtlFlag,
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical:true,
        responsive: [
          {
            breakpoint: 1550,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
            }
            },
          {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          }
          },
          {
          breakpoint: 780,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
          },
          {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ] 
        });
        $('.banner-top-content2').slick({
          dots: false,
          arrows: true,
          infinite: true,
          speed: 1000,
          fade: true,
          rtl: dirRtlFlag,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,
          cssEase: 'linear',
          pauseOnHover: false
        });

      })

